import DOMPurify from 'dompurify';
import React, { useState, useEffect, useRef } from 'react';
import ImageModal from './ImageModal';

interface CookedTextProps {
  cookedHtml: string;
}

const CookedText: React.FC<CookedTextProps> = ({ cookedHtml }) => {
  const [modalImage, setModalImage] = useState<string | null>(null);
  const contentRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handleImageClick = (event: MouseEvent) => {
      const target = event.target as HTMLElement;

      // Find the <a> tag wrapping an <img>
      const anchor = target.closest('a.lightbox') as HTMLAnchorElement | null;
      if (anchor && anchor.querySelector('img')) {
        event.preventDefault();
        const img = anchor.querySelector('img') as HTMLImageElement;
        if (img) {
          setModalImage(anchor.href); // Use the full-sized image URL
        }
      }
    };

    const contentEl = contentRef.current;
    if (contentEl) {
      contentEl.addEventListener('click', handleImageClick);
    }

    return () => {
      if (contentEl) {
        contentEl.removeEventListener('click', handleImageClick);
      }
    };
  }, [cookedHtml]);

  return (
    <>
      <div
        ref={contentRef}
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(cookedHtml) }}
        className='text-sm text-left text-gray-600 written-text cooked-html'
      />
      {modalImage && (
        <ImageModal
          src={modalImage}
          alt='Image'
          onClose={() => setModalImage(null)}
        />
      )}
    </>
  );
};

export default CookedText;
